import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("agi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("agi_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errDetail(e) {
  const d = e.response?.data?.detail;
  if (d === "subscription_locked") return "Your subscription has expired — renew on the Billing page to continue.";
  if (d === "token_pool_exhausted") return "Your team's token pool is used up for this period — buy more tokens on the Billing page.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e.message || "Something went wrong";
}

export default api;
